import {config} from '../../environment';

export const questionsManual = [
  {
    step: 1,
    title: 'Choose your make',
    suggest: 'Volkswagen',
    id: 'make',
    data: [],
  },
  {
    step: 2,
    title: 'Choose your model',
    id: 'model',
    data: [],
  },
  {
    step: 3,
    title: 'Choose your year',
    id: 'year',
    data: [],
  },
  {
    step: 4,
    title: 'Choose your variant',
    id: 'varient',
    data: [],
  },
  {
    step: 5,
    title: 'Nice, are these details correct?',
    data: [],
  },
];

export const ENV_GLOBAL = config.API_BASE_URL;
export const QUESTION_MANUAL_API = `${ENV_GLOBAL}/redbook`;

export const LOCALITY_SEARCH = `${ENV_GLOBAL}/vw/locality-search`;
